import { BaseObjectEntity } from '@/types';

export const ROOTS_NOTIFICATIONS = '/notifications';

export const PATH_NOTIFICATIONS: BaseObjectEntity = {
  root: ROOTS_NOTIFICATIONS,
};
